import Base64 from 'base64-js';
import { useStore } from '~/shared/hooks/useStore';

export const isRequireConfirmation = () => {
    const { CAuthorization: { hash } } = useStore();

    if (!hash) {
        return false;
    }

    const originalHash = hash.slice(1);
    const decodedHash = new TextDecoder().decode(Base64.toByteArray(originalHash));  
    const authData = JSON.parse(decodedHash);
    return Object.prototype.hasOwnProperty.call(authData, 'code_confirmation') && authData.code_confirmation;
};
